import { render, staticRenderFns } from "./Deselect.vue?vue&type=template&id=0cbb7eb8&scoped=true"
var script = {}
import style0 from "./Deselect.vue?vue&type=style&index=0&id=0cbb7eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb7eb8",
  null
  
)

export default component.exports